import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./developer.css"; // optional if you want to add custom styling

const TeamSection = () => {
  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  return (
    <>
      <Header />
      {/* TEAM SECTION START */}
      <section id="myteamsection" className="py-5 team-section-top">
        <div className="container">
          {/* Founder / CEO Profile */}
          <div className="row align-items-center mb-5">
            <div className="col-lg-7 col-md-12">
              <h4 className="fw-semibold mb-1">Mr Parmod Kumar Gupta</h4>
              <div className="text-uppercase text-muted small mb-3">
                A Real Estate Visionary
              </div>
              <p className="text-muted">
                With nearly 40 years of experience, Mr. Parmod Kumar Gupta is a
                true visionary who believes real estate is about building lives
                and nurturing communities, not just constructing buildings.
                <br />
                <br />
                Known for his down-to-earth nature and people-first approach,
                Mr. Gupta's journey is a timeline of entrepreneurial success. It
                began in the mid-nineties, pioneering the floor concept with
                Spring Field (1995) and Green Fields (1998), followed by
                founding Faridabad's first mall, Crown Plaza (1999). His focus
                on large-scale community development led to founding RPS in 2002
                (launching RPS Green Valley and RPS Paras Apartments (2004)). He
                then developed World Street (2010), the city's largest
                commercial center, before delivering Aagman (2015) and the
                massive TownFit70 (2021) township. His vision continues with the
                projected Barsana Aanandam Valleey in 2025.
                <br />
                <br />
                His strategic leadership has transformed ventures like Crown
                Group, Aagman, and RPS Faridabad into thriving ecosystems where
                families flourish. Driven by a commitment to belonging and joy,
                Mr. Parmod Kumar Gupta remains a guiding force in shaping not
                just skylines, but lives within them.
              </p>
            </div>
            <div className="col-lg-5 col-md-12 text-center">
              <img
                src={`${IMAGE_BASE_URL}/parmod.jpeg`}
                alt="Sumit Shree - Founder & CEO"
                className="img-fluid rounded-circle main-img"
              />
            </div>
          </div>

          {/* Team Members */}
          <div className="row gy-4">
            {/* Team Member 1 */}
            <div className="col-md-6">
              <div className="team-card shadow-sm rounded p-4 d-flex align-items-start gap-3">
                <img
                  // src="/image/WhatsApp Image 2025-10-28 at 12.40.34.jpeg"
                  src={`${IMAGE_BASE_URL}/Manmohan.jpeg`}
                  alt="Raj Kumar - Sales Head"
                  className="small-img"
                />
                <div>
                  <h6 className="fw-semibold mb-1">Mr. Manmohan Mangla</h6>
                  <div className="text-uppercase text-muted small mb-2">
                    Visionary Business Leader & Real Estate Developer
                  </div>
                  <p className="text-muted mb-0">
                    Manmohann Mangla – Visionary Business Leader & Real Estate
                    Developer With over 30 years of experience in business
                    management, Manmohann Mangla began his entrepreneurial
                    journey in the gold jewellery sector, successfully managing
                    a prominent showroom. He later diversified into other
                    ventures, including operating a petrol pump, before entering
                    the real estate domain nearly 15 years ago. His real estate
                    journey began with Shri Keshav Realtors, where one of his
                    landmark achievements was the development of Nature View
                    Apartments in Nainital—a project that stands as a testament
                    to his vision and execution.
                  </p>
                </div>
              </div>
            </div>

            {/* Team Member 2 */}
            <div className="col-md-6">
              <div className="team-card shadow-sm rounded p-4 d-flex align-items-start gap-3">
                <img
                  // src="/image/WhatsApp Image 2025-10-28 at 12.40.33 (1).jpeg"
                  src={`${IMAGE_BASE_URL}/Radha.jpeg`}
                  alt="Neha Verma - Marketing Head"
                  className="small-img"
                />
                <div>
                  <h6 className="fw-semibold mb-1">Mr. Radha Madhav Jindal</h6>
                  {/* <div className="text-uppercase text-muted small mb-2">
                    Marketing & Communications Head
                  </div> */}
                  <p className="text-muted mb-0">
                    {/* Neha specializes in brand communication and digital
                    outreach. She ensures Barsana Villages properties reach the
                    right audience with compelling stories that reflect trust,
                    lifestyle, and value. */}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* TEAM SECTION END */}
      <Footer />
    </>
  );
};

export default TeamSection;
